import adapter from 'webrtc-adapter';
import Janus from "./janus-es"

export default {
    install: function(Vue, options) {

        Object.defineProperty(Vue.prototype, '$janus', { value: Janus });
        let listeners = new Map();

        let emit = (label, ...args) => {
            let curListeners = listeners.get(label);
            if (curListeners && curListeners.length) {
                curListeners.forEach((listener) => {
                    listener.callback.call(listener.vm,...args)
                });
                return true;
            }
            return false;
        };

        let janusStarted = false;
        let janus = null;
        let janusPluginHandle = null;
        let janusUsername = null;
        let janusRoom = null; //20181; //20161
        let janusMyId = null;
        let janusMyPvtId = null;
        let janusPlugin = "janus.plugin.videoroom";
        let janusStreamingPlugin = "janus.plugin.streaming";
        let janusOpaqueId = "VidRoom" + Janus.randomString(12);
        let janusFeeds = [];
        let janusMyStream = null;
        let janusTimers = {};

        let publishOwnFeed = (useAudio) => {
            janusPluginHandle.createOffer({
                media:{ audioRecv: false, videoRecv: false, audioSend: useAudio, videoSend: true },
                simulcast: false,
                success:function(jsep) {
                    janusPluginHandle.send({"message": { "request": "configure", "audio": useAudio, "video": true }, "jsep": jsep});
                },
                error:function (error) {
                    console.log(error);
                    if (useAudio) {
                        publishOwnFeed(false);
                    } else {
                        emit('error', 'GeneralError');
                    }
                }
            })
        };

        // let forwardOwnFeed = () => {
            // if(janusRoom !== 20192) return;
            // let forward = {
            //     request: "rtp_forward",
            //     room: janusRoom,
            //     publisher_id: janusMyId,
            //     // host: "127.0.0.1",
            //     // host: "188.39.21.66",
            //     // host: "172.31.9.186",
            //     // host: "janus3.reactoo.co.uk",
            //     // host: "0.0.0.0",
            //     // host: "8.8.8.8",
            //     host: "172.31.14.215",
            //     audio_port: 4010,
            //     video_port: 4001,
            //     video_ptype: 126
            // };
            // janusPluginHandle.send({
            //     message: forward,
            //     success:function(jsep) {
            //         // console.log('===================================================================');
            //         // console.log(forward);
            //         // console.log(jsep);
            //         // console.log('===================================================================');
            //     },
            //     error:function (error) {
            //         // console.log('===================================================================');
            //         // console.log(forward);
            //         // console.log(error);
            //         // console.log('===================================================================');
            //     }
            // });
        // };

        let newStreamingFeed = (id) => {
            if(id !== 20192) return;
            let remoteFeed = null;
            janus.attach({
                plugin: janusStreamingPlugin,
                opaqueId: janusOpaqueId,
                success: function(pluginHandle) {
                    remoteFeed = pluginHandle;
                    remoteFeed.simulcastStarted = false;
                    // remoteFeed.send({"message": { "request": "list" }, success: function(result) {
                    //     console.log('==============================================');
                    //     console.log(result);
                    //     console.log('==============================================');
                    // }});
                    remoteFeed.send({"message": { "request": "watch", id: 1 }});
                },
                error: function(error) {
                    console.warn("  -- Error attaching plugin...", error);
                },
                onmessage: function(msg, jsep) {
                    if(jsep !== undefined && jsep !== null) {
                        remoteFeed.createAnswer({
                            jsep: jsep,
                            media: { audioSend: false, videoSend: false },	// We want recvonly audio/video
                            success: function(jsep) {
                                remoteFeed.send({"message": { "request": "start" }, "jsep": jsep});
                            },
                            error: function(error) {
                                console.log("WebRTC error:", error);
                            }
                        });
                    }
                },
                onremotestream: function(stream) {
                    let videoTracks = stream.getVideoTracks();
                    remoteFeed.rfdisplay = 'test';
                    emit('addMainStream', remoteFeed.id, remoteFeed.rfdisplay, stream, videoTracks && videoTracks.length);

                    if(Janus.webRTCAdapter.browserDetails.browser === "chrome" || Janus.webRTCAdapter.browserDetails.browser === "firefox" ||
                        Janus.webRTCAdapter.browserDetails.browser === "safari") {

                        janusTimers[remoteFeed.id] = setInterval(function () {
                            let bitrate = remoteFeed.getBitrate();
                            console.log(remoteFeed);
                            emit('streamBitrate', remoteFeed.id, bitrate);
                        }, 2000);

                    }
                },
            });
        };

        let newRemoteFeed = (id, display, audio, video) => {
            let remoteFeed = null;
            janus.attach({
                plugin: janusPlugin,
                opaqueId: janusOpaqueId,
                success: function(pluginHandle) {
                    remoteFeed = pluginHandle;
                    remoteFeed.simulcastStarted = false;
                    let listen = { "request": "join", "room": janusRoom, "ptype": "listener", "feed": id, "private_id": janusMyPvtId };

                    //TODO: look current state
                    if(video !== "h264" && Janus.webRTCAdapter.browserDetails.browser === "safari") {
                        if(video) video = video.toUpperCase();
                        listen["offer_video"] = false;
                    }

                    remoteFeed.send({"message": listen});
                },
                error: function(error) {
                    console.warn("  -- Error attaching plugin...", error);
                },
                onmessage: function(msg, jsep) {

                    console.log(msg);
                    console.log(jsep);

                    let event = msg["videoroom"];

                    if(msg["error"] !== undefined && msg["error"] !== null) {
                        console.warn("  -- Error on message...", msg["error"]);
                    }

                    else if(event != undefined && event != null) {

                        if(event === "attached") {
                            remoteFeed.rfid = msg["id"];
                            remoteFeed.rfdisplay = msg["display"];
                            janusFeeds.push(remoteFeed);

                            //TODO: add "connecting" message event
                        }

                        else if(event === "event") {
                            var substream = msg["substream"];
                            var temporal = msg["temporal"];
                            if((substream !== null && substream !== undefined) || (temporal !== null && temporal !== undefined)) {
                                if(!remoteFeed.simulcastStarted) {
                                    remoteFeed.simulcastStarted = true;
                                }
                            }
                        }

                        else {
                            //meh
                        }
                    }

                    if(jsep !== undefined && jsep !== null) {
                        remoteFeed.createAnswer(
                            {
                                jsep: jsep,
                                // Add data:true here if you want to subscribe to datachannels as well
                                // (obviously only works if the publisher offered them in the first place)
                                media: { audioSend: false, videoSend: false },	// We want recvonly audio/video
                                success: function(jsep) {
                                    console.log(jsep);
                                    let body = { "request": "start", "room": janusRoom };
                                    remoteFeed.send({"message": body, "jsep": jsep});
                                },
                                error: function(error) {
                                    console.log("WebRTC error:", error);

                                }
                            });
                    }
                },
                webrtcState: function(on) {
                    console.log("Janus says this WebRTC PeerConnection (feed #" + remoteFeed.rfid + ") is " + (on ? "up" : "down") + " now");
                },
                onlocalstream: function(stream) {

                    // nothing to here

                },
                onremotestream: function(stream) {

                    //TODO: this is called multiple times for one feed causing problems with interval etc

                    let videoTracks = stream.getVideoTracks();
                    emit('addParticipant', remoteFeed.rfid, remoteFeed.rfdisplay, stream, videoTracks && videoTracks.length);

                    if(Janus.webRTCAdapter.browserDetails.browser === "chrome" || Janus.webRTCAdapter.browserDetails.browser === "firefox" ||
                        Janus.webRTCAdapter.browserDetails.browser === "safari") {

                        janusTimers[remoteFeed.rfid] = setInterval(function () {
                            let bitrate = remoteFeed.getBitrate();
                            emit('streamBitrate', remoteFeed.rfid, bitrate);
                        }, 2000);

                    }

                },
                oncleanup: function() {
                    clearInterval(janusTimers[remoteFeed.rfid]);
                    remoteFeed.simulcastStarted = false;

                },
            });
        };


        Object.defineProperty(Vue.prototype, '$videoroom', {value: {
            destroy () {
              if(janus) {
                  janusMyStream.getTracks().forEach(track => track.stop());
                  janusStarted = false;
                  janus.destroy();
                  janus = null;
                  janusPluginHandle = null;
                  janusUsername = null;
                  janusRoom = null;
                  janusMyId = null;
                  janusMyPvtId = null;
                  janusFeeds = [];
                  janusMyStream = null;
                  janusTimers = {};
              }
            },
            init (roomId) {
                janusRoom = roomId;
                Janus.init({debug:'all', dependencies: Janus.useDefaultDependencies({
                        adapter
                    }), callback: function () {

                        if(janusStarted) return;
                        janusStarted = true;

                        if(!Janus.isWebrtcSupported()) {
                            return
                        }

                        janus = new Janus({
                            server:options.server,
                            iceServers: options.iceServers,
                            success: function() {

                                newStreamingFeed(roomId);

                                janus.attach(
                                    {
                                        plugin: janusPlugin,
                                        opaqueId: janusOpaqueId,
                                        success: function(pluginHandle) {
                                            console.log(`Plugin attached`);
                                            janusPluginHandle = pluginHandle;
                                            console.log('RoomId' + janusRoom);
                                            janusUsername = `Demo-${Janus.randomString(6)}`;
                                            janusPluginHandle.send({"message": {
                                                    "request": "join", "room": janusRoom, "ptype": "publisher", "display": janusUsername
                                                }})
                                        },
                                        error: function(error) {
                                            console.log(error);
                                            emit('error', 'GeneralError');
                                        },
                                        consentDialog: function(on) {
                                            emit('consentDialog', on);
                                        },
                                        mediaState: function(medium, on) {
                                            console.log("Janus " + (on ? "started" : "stopped") + " receiving our " + medium);
                                        },
                                        webrtcState: function(on) {
                                            console.log("Janus says our WebRTC PeerConnection is " + (on ? "up" : "down") + " now");
                                            janusPluginHandle.send({"message": { "request": "configure", "bitrate": 128000 }});

                                            emit('isLocalParticipantReady', true);
                                        },
                                        onmessage: function(msg, jsep) {

                                            console.log(msg);
                                            console.log(jsep);

                                            let event = msg["videoroom"];
                                            if(event !== undefined && event !== null) {

                                                if(event === "joined") {

                                                    janusMyId = msg["id"];
                                                    janusMyPvtId = msg["private_id"];

                                                    publishOwnFeed(true);
                                                    // forwardOwnFeed(true);

                                                    if(msg["publishers"] !== undefined && msg["publishers"] !== null) {
                                                        let list = msg["publishers"];
                                                        for(let f in list) {
                                                            let id = list[f]["id"];
                                                            let display = list[f]["display"];
                                                            let audio = list[f]["audio_codec"];
                                                            let video = list[f]["video_codec"];
                                                            Janus.debug("  >> [" + id + "] " + display + " (audio: " + audio + ", video: " + video + ")");
                                                            newRemoteFeed(id, display, audio, video);
                                                        }
                                                    }
                                                }

                                                else if(event === "destroyed") {
                                                    console.log('Room destroyed')
                                                }

                                                else if(event === "event") {

                                                    if(msg["publishers"] !== undefined && msg["publishers"] !== null) {
                                                        let list = msg["publishers"];
                                                        for(let f in list) {
                                                            let id = list[f]["id"];
                                                            let display = list[f]["display"];
                                                            let audio = list[f]["audio_codec"];
                                                            let video = list[f]["video_codec"];
                                                            Janus.debug("  >> [" + id + "] " + display + " (audio: " + audio + ", video: " + video + ")");
                                                            newRemoteFeed(id, display, audio, video);
                                                        }
                                                    }

                                                    else if(msg["leaving"] !== undefined && msg["leaving"] !== null) {
                                                        let leaving = msg["leaving"];
                                                        let remoteFeed = janusFeeds.find(feed => feed != null && feed != undefined && feed.rfid == leaving);
                                                        if(remoteFeed) {

                                                            emit('removeParticipant', remoteFeed.rfid);

                                                            const index = janusFeeds.indexOf(remoteFeed);
                                                            if (index !== -1) {
                                                                janusFeeds.splice(index, 1);
                                                            }

                                                            remoteFeed.detach();
                                                        }
                                                    }

                                                    else if(msg["unpublished"] !== undefined && msg["unpublished"] !== null) {
                                                        let unpublished = msg["unpublished"];
                                                        if(unpublished === 'ok') {
                                                            // That's us
                                                            janusPluginHandle.hangup();
                                                            return;
                                                        }
                                                        let remoteFeed = janusFeeds.find(feed => feed != null && feed != undefined && feed.rfid == unpublished);
                                                        if(remoteFeed) {

                                                            emit('removeParticipant', remoteFeed.rfid);

                                                            const index = janusFeeds.indexOf(remoteFeed);
                                                            if (index !== -1) {
                                                                janusFeeds.splice(index, 1);
                                                            }

                                                            remoteFeed.detach();
                                                        }
                                                    }

                                                    else if(msg["error"] !== undefined && msg["error"] !== null) {
                                                        if(msg["error_code"] === 426) {
                                                            console.warn('No such room exists');
                                                        } else {
                                                            console.warn(msg['error']);
                                                        }
                                                        emit('error', 'GeneralError');
                                                    }
                                                }
                                            }

                                            if(jsep !== undefined && jsep !== null) {
                                                janusPluginHandle.handleRemoteJsep({jsep: jsep});
                                                let audio = msg["audio_codec"];
                                                let video = msg["video_codec"];

                                            }

                                        },
                                        onlocalstream: function(stream) {
                                            janusMyStream = stream;

                                            let videoTracks = stream.getVideoTracks();
                                            emit('addLocalParticipant', janusUsername, stream, videoTracks && videoTracks.length);

                                            console.log(`IceConnectionState:${janusPluginHandle.webrtcStuff.pc.iceConnectionState}`);

                                            if(janusPluginHandle.webrtcStuff.pc.iceConnectionState !== "completed" &&
                                                janusPluginHandle.webrtcStuff.pc.iceConnectionState !== "connected") {
                                                emit('isLocalParticipantReady', false);
                                            }
                                            else {
                                                emit('isLocalParticipantReady', true);
                                            }

                                        },
                                        onremotestream: function() {
                                            // doing nothing here
                                        },
                                        oncleanup: function() {
                                            console.log('We got cleanup');
                                            janusMyStream.getTracks().forEach(track => track.stop());
                                            janusMyStream = null;
                                            emit('removeLocalParticipant');
                                        }
                                    });

                            },
                            error: function (e) {
                                Janus.error(e);
                                emit('error', 'GeneralError');
                            },
                            destroyed: function () {
                                console.log('Done!');
                                emit('destroy');
                            }
                        });

                    }});

            }
        }});


        Vue.mixin({
            created() {

                let videoroom = this.$options.videoroom;
                this.$options.videoroom = new Proxy({}, {
                    set: (target, key, value) => {

                        if(typeof value === 'function') {
                            listeners.has(key) || listeners.set(key, []);
                            listeners.get(key).push({callback: value, vm: this});
                        }
                        target[key] = value;
                        return true;
                    },
                    deleteProperty: (target, key) => {

                        let lo_listeners = listeners.get(key),
                            index;

                        if (lo_listeners && lo_listeners.length) {
                            index = lo_listeners.reduce((i, listener, index) => {
                                return (typeof listener.callback === 'function' && listener.callback === this.$options.videoroom[key] && listener.vm == this) ?
                                    i = index :
                                    i;
                            }, -1);

                            if (index > -1) {
                                lo_listeners.splice(index, 1);
                                listeners.set(key, lo_listeners);
                            }
                        }
                        delete target.key;
                        return true
                    }
                });

                if(videoroom){
                    Object.keys(videoroom).forEach((key) => {
                        this.$options.videoroom[key] = videoroom[key];
                    });
                }

            },
            beforeDestroy() {
                let videoroom = this.$options['videoroom'];
                if(videoroom) {
                    Object.keys(videoroom).forEach((key) => {
                        delete this.$options.videoroom[key]
                    });
                }
            }
        })

    }
}


// WEBPACK FOOTER //
// ./src/plugins/videoroom.js